export async function run({ elements: { background, button, title }, sound, pixiContext, }) {
    background.sprite.visible = true;
    button.sprite.visible = true;
    title.sprite.visible = true;
    background.sprite.play();
    title.sprite.play();
    sound.playLoop("background");
    button.sprite.alpha = 0;
    await pixiContext.fadeIn({
        durationMS: 1000,
        sprite: button.sprite,
    });
    sound.playLoop("pleaseClick");
}
//# sourceMappingURL=loadingAnimation.js.map